import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV = [
  { to:'/dashboard',     label:'Dashboard',      icon:'📊', key:'dashboard' },
  { to:'/billing',       label:'New Bill',        icon:'🧾', key:'billing' },
  { to:'/online-orders', label:'Website Orders',  icon:'🌐', key:'online-orders' },
  { to:'/orders',        label:'Dine-in Orders',  icon:'📋', key:'orders' },
  { to:'/inventory',     label:'Inventory',       icon:'📦', key:'inventory' },
  { to:'/recipes',       label:'Recipes',         icon:'👨‍🍳', key:'recipes' },
  { to:'/consumption',   label:'Consumption',     icon:'📉', key:'consumption' },
  { to:'/loyalty',       label:'Loyalty',         icon:'⭐', key:'loyalty' },
  { to:'/users',         label:'Users',           icon:'👥', key:'users' },
  { to:'/reports',       label:'Reports',         icon:'📈', key:'reports' },
  { to:'/admin',         label:'Admin Panel',     icon:'⚙️', key:'admin-panel' },
];

export default function Sidebar() {
  const { can } = useAuth();
  return (
    <div style={{ width:200, background:'#fff', borderRight:'1px solid #eee',
                  display:'flex', flexDirection:'column', flexShrink:0, overflowY:'auto' }}>
      <div style={{ padding:'16px 16px 14px', fontSize:16, fontWeight:600,
                    borderBottom:'1px solid #eee', marginBottom:8 }}>
        🍕 <span style={{ color:'#D85A30' }}>Pizza</span>Bill
      </div>
      {NAV.filter(n => can(n.key)).map(n => (
        <NavLink key={n.to} to={n.to} style={({ isActive }) => ({
          display:'flex', alignItems:'center', gap:10, padding:'9px 16px',
          fontSize:13, color: isActive ? '#993C1D' : '#555',
          background: isActive ? '#FAECE7' : 'transparent',
          fontWeight: isActive ? 500 : 400, textDecoration:'none',
        })}>
          <span>{n.icon}</span> {n.label}
        </NavLink>
      ))}
    </div>
  );
}